export const queryAllData = `
  id
  deletedAt
  isApplicant
  moveInDate
  notCalculateMoveInDate
  moveOutDate
  notCalculateMoveOutDate
  moveOutReason
  billAccommodationAndLodgingPrivatelyInMoveOutMonth
  prescriptionFeeUntil
  prescriptionFeeNote
  prescriptionFeeNoteText
  prescriptionFeeWeeksBeforeExpiry
  lastApplicationDate
  lastMdkDate
  performanceSurcharge
  nextLevelStartDate
  remark
  careLevels {
    level
    date
    provisional
  }
  carePeriods {
    type
    startDate
    endDate
  }
  absences {
    type
    startDate
    endDate
    comment
  }
  suppressPflegegradHint
`;
